<template>
	<JBox
		class="s-relative s-flex s-bg-gray-100 s-flex-wrap s-min-h-screen s-overflow-y-scroll"
		:style="
			`background-image: radial-gradient(rgba(0,0,0,0.08) 15%, rgba(0,0,0,0) 0%); background-position: 0 0; background-size: 14px 14px;`
		"
		@click.self="$store.dispatch('uiEditor/selectNode', null)"
	>
		<!-- HACK: just to get all the components from AIA here -->
		<!-- <JBox @click="initAia" class="s-fixed s-z-50 s-bg-red-100">init AIA</JBox> -->

		<!-- Top bar -->
		<!-- TODO: its own component -->
		<Transition enter-active-class="animated fadeInDown fastest" leave-active-class="animated fadeOutUp fastest">
			<JBox class="s-w-full s-bg-white s-shadow-sm s-absolute s-top-0" v-if="hasInspectors">
				<JFlex class="s-justify-center s-items-center s-h-10">
					<JFlex class="s-justify-center s-items-center s-h-10">
						<JFlex class="s-w-64 s-h-10 s-items-center">
							<JSelect
								variant="ghost"
								placeholder="Select Component"
								class="s-px-2 s-overflow-hidden s-p-1 s-rounded s-w-full s-bg-gray-100 s-text-sm s-text-gray-500"
								:options="components"
								@input="selectComponent"
								:value="selectedComponentId"
							/>
						</JFlex>
						<JFlex
							class="s-items-center s-justify-center s-h-6 s-w-6 s-flex-shrink-0 s-ml-2 s-rounded-full s-bg-indigo-100 s-cursor-pointer"
							@click="hasCreateComponentModal = true"
						>
							<CIcon name="plus" class="s-fill-current s-text-indigo-600 s-w-5 s-h-5" />
						</JFlex>
						<JFlex
							class="s-items-center s-justify-center s-h-6 s-w-6  s-flex-shrink-0 s-ml-2 s-rounded-full s-bg-red-100 s-cursor-pointer"
							@click="hasDeleteComponentModal = true"
						>
							<CIcon name="trash" class="s-fill-current s-text-red-600 s-w-4 s-h-4" />
						</JFlex>
						<JText class="s-mr-6 s-ml-6 s-text-gray-400">|</JText>
					</JFlex>
					<JFlex class="s-justify-center s-items-center s-h-10">
						<JText class="s-mr-8 s-text-sm s-text-gray-500 s-cursor-pointer" @click="hasPagesModal = !hasPagesModal">Pages</JText>
						<JText class="s-mr-8 s-text-sm s-text-gray-500 s-cursor-pointer" @click="hasThemeModal = !hasThemeModal">Theme</JText>
						<JText class="s-mr-8 s-text-sm s-text-gray-500 s-cursor-pointer">Store</JText>
					</JFlex>
					<JFlex class="s-justify-center s-items-center s-h-10">
						<JText class="s-mr-6 s-text-gray-400">|</JText>
						<JButton variant="default-light-sm" class="s-mr-2" @click="saveComponent">Save</JButton>
						<JButton variant="white-sm">Publish</JButton>
					</JFlex>
				</JFlex>
			</JBox>
		</Transition>

		<!-- Canvas -->
		<JBox>
			<!-- When component not selected, show message and picker -->
			<JFlex class="s-mt-32 s-w-screen" v-if="!selectedComponentId">
				<JBox class="s-mx-auto s-bg-white s-p-6 s-text-center s-shadow-lg s-rounded-lg">
					<JText class="s-mb-4">Select a component to render on the canvas</JText>
					<JSelect
						variant="ghost"
						placeholder="Select Component"
						class="s-px-2 s-overflow-hidden s-p-1 s-rounded s-w-full s-bg-gray-100 s-text-sm s-text-left s-text-gray-500"
						:options="components"
						@input="selectComponent"
						:value="selectedComponentId"
					/>
				</JBox>
			</JFlex>
			<VueRenderer v-show="selectedComponentId">
				<template v-slot="{ vueApp }">
					<VueCanvas :vueApp="vueApp" />
					<!-- NOTE: can have more canvasses -->
					<!-- <VueCanvas :vueApp="vueApp" /> -->
				</template>
			</VueRenderer>
		</JBox>

		<!-- Layout Inspetor -->
		<Transition enter-active-class="animated fadeInLeft fastest" leave-active-class="animated fadeOutLeft fastest">
			<JBox class="s-fixed s-top-0 s-left-0 s-w-80 s-bg-white s-h-screen s-shadow-lg" v-if="hasInspectors">
				<JFlex class="s-border-b s-border-gray-200 s-p-2 s-justify-between">
					<JButton variant="default-light-xs" @click="hasGalleryModal = !hasGalleryModal">+ Add Element</JButton>
					<JButton variant="white-xs" @click="$store.dispatch('uiEditor/expandAllNodes')">Expand All</JButton>
				</JFlex>
				<UiEditorLayout />
			</JBox>
		</Transition>

		<!-- Node Inspetor -->
		<Transition enter-active-class="animated fadeInRight fastest" leave-active-class="animated fadeOutRight fastest">
			<JBox class="s-fixed s-top-0 s-right-0 s-w-80 s-bg-white s-h-screen s-shadow-lg s-pb-64" v-if="hasInspectors">
				<UiEditorInspector />
			</JBox>
		</Transition>

		<!-- Gallery of elements and components -->
		<Transition enter-active-class="animated fadeInUp fastest" leave-active-class="animated fadeOutDown fastest">
			<JBox v-if="hasGalleryModal && hasInspectors" class="s-w-full s-left-0 s-fixed s-bottom-0" style="height: 40vh;">
				<ElementsGallery />
			</JBox>
		</Transition>

		<!-- Action Buttons -->
		<!-- TODO: ssohuld be its own component, getting big -->
		<JBox class="s-fixed s-right-0 s-p-2" style="bottom: 140px;">
			<!-- Code -->
			<JFlex
				class="s-h-12 s-w-12 s-rounded-full s-bg-purple-800 s-shadow-lg s-text-white s-items-center s-justify-center s-cursor-pointer s-m-2"
				@click="hasCodeModal = !hasCodeModal"
			>
				<svg
					class="s-text-white s-h-6 s-w-6"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="2"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"></path>
				</svg>
			</JFlex>

			<!-- Toggle inspectors -->
			<JFlex
				class="s-h-12 s-w-12 s-rounded-full s-bg-purple-800 s-shadow-lg s-text-white s-items-center s-justify-center s-cursor-pointer s-m-2"
				@click="hasInspectors = !hasInspectors"
			>
				<svg
					class="s-text-white s-h-6 s-w-6"
					fill="none"
					stroke-linecap="round"
					stroke-linejoin="round"
					stroke-width="2"
					viewBox="0 0 24 24"
					stroke="currentColor"
				>
					<path d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"></path>
					<path
						d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
					></path>
				</svg>
			</JFlex>
		</JBox>

		<!-- Modal Create Component -->
		<CModal :isVisible="hasCreateComponentModal">
			<JBox class="s-p-8">
				<ComponentCreateForm @cancel="hasCreateComponentModal = false" @created="handleComponentCreated" />
			</JBox>
		</CModal>

		<!-- Modal Delete Component -->
		<CModal :isVisible="hasDeleteComponentModal">
			<!-- TODO: it should be its own component so that we can do more logic in there e.g. check if component is being used in router or in other apps -->
			<JBox class="s-p-8">
				<JHeadline class="s-text-lg s-mb-1">Are you sure you want to delete this component?</JHeadline>
				<JText class="s-text-gray-500"
					>If this component is being used in other components or is part of Pages, it will break the App. You should resolve
					these issues before you delete this component</JText
				>
				<JFlex class="s-justify-between s-mt-6">
					<JButton variant="error" @click="handleDeleteComponent">Delete</JButton>
					<JButton variant="white" @click="hasDeleteComponentModal = false">Cancel</JButton>
				</JFlex>
			</JBox>
		</CModal>

		<!-- Modal Pages -->
		<CModal :isVisible="hasPagesModal">
			<AppPages :appId="appId" @done="hasPagesModal = false" @cancel="hasPagesModal = false" />
		</CModal>

		<!-- Modal for theme -->
		<CModal :isVisible="hasThemeModal" variant="default">
			<AppTheme :appId="appId" @updated="hasThemeModal = false" @cancelled="hasThemeModal = false" />
		</CModal>

		<!-- Modal for code -->
		<CModal :isVisible="hasCodeModal" variant="default-large" @overlay:click="hasCodeModal = false">
			<ComponentCode />
		</CModal>
	</JBox>
</template>

<script>
import VueRenderer from "../components/renderers/VueRenderer"
import VueCanvas from "../components/renderers/VueCanvas"
import UiEditorInspector from "../components/UiEditorInspector"
import UiEditorLayout from "../components/UiEditorLayout"
import AppPages from "../components/AppPages"
import AppTheme from "../components/AppTheme"
import ElementsGallery from "../components/ElementsGallery"
import ComponentCode from "../components/ComponentCode"
import ComponentCreateForm from "../components/ComponentCreateForm"

// HACK: should be deleted
import { initAia } from "../api/__remove__resetAia.js"

export default {
	components: {
		VueRenderer,
		VueCanvas,
		UiEditorInspector,
		UiEditorLayout,
		AppTheme,
		ElementsGallery,
		AppPages,
		ComponentCode,
		ComponentCreateForm
	},

	props: {
		appId: { type: String, default: "" } // From router
	},

	data() {
		return {
			isAppLoading: false,

			// Toggle hide all inspectors
			hasInspectors: true,

			// Gallery modal
			hasGalleryModal: false,

			// Theme modal
			hasThemeModal: false,

			// Create component modal
			hasCreateComponentModal: false,

			// Delete component modal
			hasDeleteComponentModal: false,

			// Pages modal
			hasPagesModal: false,

			// Code modal
			hasCodeModal: false
		}
	},

	computed: {
		components() {
			const pages = this.$store.state?.uiEditor?.app?.componentRoutes?.map(item => item.component)?.filter(item => item) ?? []
			const pagesComponents = []
			const nonPagesComponents = []

			this.$store.state.uiEditor?.app?.components?.forEach(component => {
				if (pages.find(page => page === component.name)) pagesComponents.push(component)
				else nonPagesComponents.push(component)
			})

			return [...pagesComponents, ...nonPagesComponents]?.map(item => ({ name: item.name, value: item.id }))
		},

		selectedComponentId() {
			return this.$store.state.uiEditor.selectedComponentId
		}
	},

	methods: {
		// HACK: should be removed
		initAia,

		async loadApp() {
			this.isAppLoading = true
			await this.$store.dispatch("uiEditor/loadApp", { appId: this.appId })
			this.isAppLoading = false

			// TODO: check for errors
		},

		async saveComponent() {
			const { isSuccess } = await this.$store.dispatch("uiEditor/saveComponent", { componentId: this.selectedComponentId })
			// TODO: check for errors
			console.log({ isSuccess })
		},

		handleComponentCreated({ id }) {
			this.$store.dispatch("uiEditor/selectComponent", id)
			this.hasCreateComponentModal = false
		},

		handleDeleteComponent() {
			this.$store.dispatch("uiEditor/deleteComponent", this.selectedComponentId)
			// TODO: handle errors and do it async
			this.hasDeleteComponentModal = false
		},

		selectComponent(componentId) {
			this.$store.dispatch("uiEditor/selectComponent", componentId)
			console.log({ "Selected component": this.$store.getters?.["uiEditor/selectedComponent"] })
		}
	},

	async created() {
		this.loadApp()
	}
}
</script>
